import React from 'react';
import { Municipality, getFeesForYear, filterFees, DEFAULT_ENABLED_CATEGORIES } from '@/lib/data';

interface FylkeWidgetProps {
  municipalities: Municipality[];
  counties: string[];
  year: number;
  enabledCategories?: string[];
  dark?: boolean;
}

export const FylkeWidget: React.FC<FylkeWidgetProps> = ({
  municipalities,
  counties,
  year,
  enabledCategories = DEFAULT_ENABLED_CATEGORIES,
  dark,
}) => {
  const byCounty = counties
    .map(county => {
      const inCounty = municipalities.filter(m => m.county === county);
      const totals = inCounty
        .map(m => filterFees(getFeesForYear(m, year), enabledCategories).reduce((s, f) => s + f.amount, 0))
        .filter(t => t > 0);
      const avg = totals.length > 0 ? totals.reduce((a, b) => a + b, 0) / totals.length : 0;
      return { county, avg, count: totals.length };
    })
    .filter(x => x.count > 0);

  const maxAvg = byCounty.length > 0 ? Math.max(...byCounty.map(x => x.avg)) : 1;

  return (
    <div className="space-y-3">
      {byCounty.map(({ county, avg }) => (
        <div key={county}>
          <div className="flex justify-between text-xs mb-1">
            <span className={dark ? 'text-slate-300' : 'text-deepCharcoal'}>{county}</span>
            <span className={`tabular-nums ${dark ? 'text-slate-400' : 'text-nordicBlue'}`}>
              {avg.toFixed(0)} kr
            </span>
          </div>
          <div className={`h-1.5 rounded-full overflow-hidden ${dark ? 'bg-slate-700' : 'bg-gray-100'}`}>
            <div
              className={`h-full rounded-full ${dark ? 'bg-slate-500' : 'bg-nordicBlue/70'}`}
              style={{ width: `${Math.min(100, (avg / maxAvg) * 100)}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};
